import Container from 'typedi'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import ProductService from '@/modules/level-one/services/product.service'
import { Product } from '@/modules/level-one/interfaces/product.interface'

@Module({
  namespaced: true
})
export default class ProductStore extends VuexModule {
    products: Product[] = []

    @Mutation
    SET_PRODUCTS (payload: Product[]) {
      this.products = payload
    }

    @Action({ rawError: true })
    async fetchProducts () {
      const response: any = await Container.get(ProductService).getProducts()
      this.context.commit('SET_PRODUCTS', response.data.data)
      return response.data.data
    }

    @Action({ rawError: true })
    async createProduct (data: Partial<Product>) {
      const response = await Container.get(ProductService).createProduct(data)
      await this.context.dispatch('fetchProducts')
      return response
    }

    @Action({ rawError: true })
    async updateProduct (payload: { uuid: string, data: Partial<Product> }) {
      const response = await Container.get(ProductService).updateProduct(payload.uuid, payload.data)
      await this.context.dispatch('fetchProducts')
      return response
    }

    @Action({ rawError: true })
    async deleteProduct (payload: { uuid: string }) {
      const response = await Container.get(ProductService).deleteProduct(payload.uuid)
      await this.context.dispatch('fetchProducts')
      return response
    }

    @Action({ rawError: true })
    async uploadProductImage (payload: { uuid: string, type: 'thumbnail' | 'full', image: any }) {
      const response = await Container.get(ProductService).uploadProductImage(payload.uuid, payload.type, payload.image)
      await this.context.dispatch('fetchProducts')
      return response
    }

    @Action({ rawError: true })
    async deleteProductImage (payload: { uuid: string, type: 'thumbnail' | 'full' }) {
      const response = await Container.get(ProductService).deleteProductImage(payload.uuid, payload.type)
      await this.context.dispatch('fetchProducts')
      return response
    }
}
